export enum ProductNameLabel {
  epc = 'EPC',
  pmc = 'PMC'
}
